/**
* @name: collapse-menu
* @author: weiyong
* @date: 2023-05-11 18:49
* @description：collapse-menu
* @update: 2023-05-11 18:49
*/
<template>
<!--  logo文件-->
  <header-logo-sca :openFlag="openFlag"></header-logo-sca>
  <a-menu
    class="scaLayoutMenu"
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    :inline-collapsed="!openFlag"
    @click="menuClick"
  >
    <div class="menu-item-div" v-for="menuItem in menusRef">

      <a-menu-item class="line-item" v-if="menuItem.type==='line'" :key="menuItem.id">
        <template #icon>
          <div class="el-custom-sidebar-text el-custom-sidebar-text--collapse w100b" style="display: flex">
            <div class="el-divider el-divider--horizontal section-divider" role="separator" style="--el-border-style: solid;"></div>
            <span v-show="openFlag===true" class="section-title">{{ menuItem.label||menuItem.name }}</span>
          </div>
        </template>
      </a-menu-item>


      <a-sub-menu :key="menuItem.id" v-if="menuItem.type==='menu'">
        <template #icon>
          <xm-menu-li class="flex-div" :activeItem="isActiveItem(menuItem.id)" :openFlag="openFlag" :menuItem="menuItem"/>
        </template>
        <template #title>{{ menuItem.label||menuItem.name }}</template>

        <template v-for="sonMenuItem in menuItem.children">
            <!--子菜单-->
          <xm-menu-sub v-if="sonMenuItem.type==='menu'" :selectedKeys="selectedKeys" :openFlag="openFlag" :menuItem="sonMenuItem"/>
            <!--界面-->
          <a-menu-item  v-if="sonMenuItem.type==='page'" :key="String(sonMenuItem.id || sonMenuItem.path)" class="el-custom-sidebar-item">
            <template #icon>
              <xm-menu-li :activeItem="isActiveItem(String(sonMenuItem.id || sonMenuItem.path))" :openFlag="openFlag" :menuItem="sonMenuItem"/>
            </template>
            <span v-if="openFlag===false">{{ sonMenuItem.label||sonMenuItem.name }}</span>
          </a-menu-item>
        </template>
      </a-sub-menu>

      <a-menu-item v-if="menuItem.type==='page'"  :key="String(menuItem.id || menuItem.path)" class="el-custom-sidebar-item">
        <template #icon>
          <xm-menu-li :activeItem="isActiveItem(String(menuItem.id || menuItem.path))" :openFlag="openFlag" :menuItem="menuItem"/>
        </template>
        <span v-if="openFlag===false">{{ menuItem.label||menuItem.name }}</span>
      </a-menu-item>

    </div>
  </a-menu>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "collapse-menu",
});
</script>

<script lang="ts" setup>
import {usePageFlush} from "@/hooks/setting/usePageFlush";
import XmMenuSub from "@/layouts/layoutFrame/scaLayout/components/xm-menu-sub.vue";
import HeaderLogoSca from "@/layouts/layoutFrame/scaLayout/components/header-logo-sca.vue";
import XmMenuLi from "@/layouts/layoutFrame/scaLayout/components/xm-menu-li.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {Menu as aMenu, MenuItem as aMenuItem, SubMenu as aSubMenu} from 'ant-design-vue';
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";
import {useRouter} from "vue-router";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";
import {useI18n} from "@/hooks/web/useI18n";

const {
  getCollapsed,
  getSplit,
} = useMenuSetting();


const {prefixCls} = useDesign('collapse-menu');
const selectedKeys = ref([]);
const openKeys = ref([]);

const isActiveItem = function (key) {
  const activeItem = unref(selectedKeys).filter((itemDb) => {
    return key === itemDb
  })[0];
  if (activeItem) {
    return true;
  } else {
    return false;
  }
}

const props = defineProps({
  openFlag: {}
})
const {openFlag}=toRefs(props);

const { t } = useI18n();
const router = useRouter();
const {
  menusRef,
  genMenus,
  menuClick
}=useMenuHooks(router,t);
genMenus({hasHomeMenu:false,hasLineMenu:true});

//刷新界面的hook
usePageFlush(false,null,selectedKeys);
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-collapse-menu';

.scaLayoutMenu.ant-menu{
  .menu-item-div{
    padding: 4px 0;
    &:first-of-type{
      padding-top: 0;
    }
    &:last-of-type{
      padding-bottom: 0;
    }
  }
}

</style>
